import { useEffect } from 'react'
import FlexRow from '@components/display/FlexRow'
import FlexItem from '@components/display/FlexItem'
import Label from '@components/form/context/LabelH'
import Input from '@components/form/context/Input'
import { useFormContext } from 'react-hook-form'

const poczatkowaOplata = { t: 'Początkowa opłata', name: 'leasing-oplata', type: 'number', unit: 'zł' }
const miesiecznaRata = { t: 'Miesięczna rata', name: 'leasing-rata', type: 'number', unit: 'zł' }
const liczbaRat = { t: 'Liczba rat', name: 'leasing-liczba-rat', type: 'number' }
const wartoscWykupu = { t: 'Wartość wykupu', name: 'leasing-wartosc-wykupu', type: 'number', unit: 'zł' }

const LeasingRow = () => {
    const { watch, unregister } = useFormContext()
    const leasingOn = Boolean(watch('leasing'))

    useEffect(() => {
        if (!leasingOn) {
            [poczatkowaOplata, miesiecznaRata, liczbaRat, wartoscWykupu].forEach(i => {
                unregister(i.name)
            })
        }
    }, [leasingOn])

    return leasingOn
        ? (
            <FlexRow>
                <FlexItem>
                    <Label text="Leasing" />
                    <Input {...poczatkowaOplata} />
                    <Input {...miesiecznaRata} />
                    <Input {...liczbaRat} />
                    <Input {...wartoscWykupu} />
                </FlexItem>
            </FlexRow>
          )

        : null
}

export default LeasingRow